webpackJsonp([114276838955818,60335399758886],{

/***/ 106:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(205);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(106);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pme-logo.9ca4ca79.svg";

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OLXLogo = __webpack_require__(204);
	
	var _OLXLogo2 = _interopRequireDefault(_OLXLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { id: 'footer' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.olxgroup.com', target: '_blank' },
	        _react2.default.createElement(_OLXLogo2.default, null)
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pmeLogo = __webpack_require__(479);
	
	var _pmeLogo2 = _interopRequireDefault(_pmeLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { id: 'header' },
	      _react2.default.createElement('div', { className: 'ellipse' }),
	      _react2.default.createElement('div', { className: 'innerEllipse' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'a',
	          { href: '/' },
	          _react2.default.createElement('img', { src: _pmeLogo2.default, id: 'pme-logo', title: 'Home' })
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'menu' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'actions' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/building-trust#one', className: 'button' },
	          'Building Trust'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/coaching-people#one', className: 'button' },
	          'Coaching People'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/inspiring-team#one', className: 'button' },
	          'Inspiring Team'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/encouraging-initiative#one', className: 'button' },
	          'Encouraging Initiative'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/providing-recognition#one', className: 'button' },
	          'Providing Recognition'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OLXLogo = function OLXLogo() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "191px", height: "58px", viewBox: "0 0 191 58", version: "1.1" },
	    _react2.default.createElement(
	      "g",
	      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { className: "color", transform: "translate(-27.000000, -14.000000)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(27.000000, 14.000000)" },
	          _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("path", { d: "M17.5489149,28.9534711 L29.0419305,28.9534711 L29.0419305,40.4397911 C22.6945658,40.4397911 17.5489149,35.2971244 17.5489149,28.9534711 Z M29.0419305,48.2540667 C18.3762377,48.2540667 9.72977988,39.6129689 9.72977988,28.9534711 C9.72977988,18.2942311 18.3762377,9.65313333 29.0419305,9.65313333 L29.0419305,28.9534711 L48.354081,28.9534711 C48.354081,39.6129689 39.7077522,48.2540667 29.0419305,48.2540667 Z M29.0419305,0.00283555556 C13.0431978,0.00283555556 0.0737690749,12.9645467 0.0737690749,28.9534711 C0.0737690749,44.9426533 13.0431978,57.9043644 29.0419305,57.9043644 C45.040792,57.9043644 58.0102208,44.9426533 58.0102208,28.9534711 C58.0102208,12.9645467 45.040792,0.00283555556 29.0419305,0.00283555556 L29.0419305,0.00283555556 Z" }),
	            _react2.default.createElement("path", { d: "M76.5940952,33.3501289 C77.132661,33.3501289 77.6753538,33.2519156 78.2216577,33.05536 C78.7677036,32.8588044 79.2591965,32.5498578 79.6960074,32.1274889 C80.1329473,31.7055067 80.4896698,31.1667511 80.7664328,30.5119956 C81.0429379,29.8569822 81.1814483,29.0711467 81.1814483,28.1541022 C81.1814483,27.2373156 81.0429379,26.4513511 80.7664328,25.7963378 C80.4896698,25.1413244 80.1292073,24.6033422 79.6850452,24.1808444 C79.2407542,23.7589911 78.7457792,23.4495289 78.1997333,23.2531022 C77.6535584,23.0565467 77.1184747,22.9583333 76.5940952,22.9583333 C76.0698447,22.9583333 75.534632,23.0565467 74.9884571,23.2531022 C74.4424112,23.4495289 73.9471783,23.7589911 73.5031452,24.1808444 C73.0587252,24.6033422 72.6982627,25.1413244 72.4217576,25.7963378 C72.1449946,26.4513511 72.0066131,27.2373156 72.0066131,28.1541022 C72.0066131,29.0711467 72.1411256,29.8569822 72.4107954,30.5119956 C72.6802073,31.1667511 73.0334477,31.7055067 73.4703876,32.1274889 C73.9073275,32.5498578 74.3986914,32.8588044 74.9448663,33.05536 C75.4909122,33.2519156 76.0405692,33.3501289 76.5940952,33.3501289 Z M76.5940952,36.0134889 C75.5744828,36.0134889 74.6063282,35.8496711 73.6887286,35.5221644 C72.7712579,35.1949156 71.9628933,34.70372 71.2641506,34.0487067 C70.5650209,33.3936933 70.011366,32.5749911 69.6038305,31.5927289 C69.1959082,30.6102089 68.9921404,29.4638711 68.9921404,28.1541022 C68.9921404,26.8588978 69.2031303,25.7199067 69.6256259,24.7376444 C70.0478636,23.7551244 70.6087407,22.9364222 71.3076124,22.2814089 C72.0066131,21.6266533 72.8149777,21.1319778 73.7324483,20.7969956 C74.649919,20.4624 75.6036293,20.2949733 76.5940952,20.2949733 C77.5843032,20.2949733 78.5382714,20.4624 79.4557421,20.7969956 C80.3732127,21.1319778 81.1814483,21.6266533 81.880578,22.2814089 C82.5795787,22.9364222 83.1399399,23.7551244 83.5625645,24.7376444 C83.9848022,25.7199067 84.19605,26.8588978 84.19605,28.1541022 C84.19605,29.4638711 83.9920243,30.6102089 83.5844889,31.5927289 C83.1765665,32.5749911 82.6232984,33.3936933 81.9242978,34.0487067 C81.2251681,34.70372 80.4169325,35.1949156 79.4994619,35.5221644 C78.5819912,35.8496711 77.6133207,36.0134889 76.5940952,36.0134889 L76.5940952,36.0134889 Z" }),
	            _react2.default.createElement("path", { d: "M86.5770371,20.9497289 C86.5770371,20.6588267 86.7225118,20.5131822 87.013977,20.5131822 L88.9800777,20.5131822 C89.2712849,20.5131822 89.4168886,20.6588267 89.4168886,20.9497289 L89.4168886,33.1317911 L96.7348582,33.1317911 C97.0259365,33.1317911 97.1716691,33.2774356 97.1716691,33.5683378 L97.1716691,35.3584756 C97.1716691,35.6500222 97.0259365,35.79528 96.7348582,35.79528 L87.013977,35.79528 C86.7225118,35.79528 86.5770371,35.6500222 86.5770371,35.3584756 L86.5770371,20.9497289" }),
	            _react2.default.createElement("path", { d: "M102.632773,27.76112 L98.5914659,21.0371156 C98.5330439,20.9354222 98.5040263,20.8481644 98.5040263,20.7750844 C98.5040263,20.6005689 98.6132613,20.5131822 98.8316023,20.5131822 L101.212718,20.5131822 C101.387598,20.5131822 101.514759,20.5349644 101.595105,20.5785289 C101.674936,20.6222222 101.758893,20.7097378 101.846204,20.8406889 L104.31476,25.0105022 L106.804982,20.8406889 C106.892421,20.7097378 106.975992,20.6222222 107.056338,20.5785289 C107.136169,20.5349644 107.263846,20.5131822 107.438596,20.5131822 L109.819712,20.5131822 C110.038053,20.5131822 110.147288,20.6005689 110.147288,20.7750844 C110.147288,20.8481644 110.118013,20.9354222 110.059849,21.0371156 L106.01867,27.76112 L110.540379,35.3147822 C110.598544,35.3877333 110.627819,35.4676444 110.627819,35.5550311 C110.627819,35.71524 110.525806,35.79528 110.322038,35.79528 L107.657066,35.79528 C107.452912,35.79528 107.314659,35.7589333 107.241922,35.6859822 C107.168926,35.6132889 107.089096,35.5043778 107.001656,35.3584756 L104.31476,30.7521156 L101.605939,35.3584756 C101.518628,35.5043778 101.438411,35.6132889 101.365802,35.6859822 C101.292678,35.7589333 101.154425,35.79528 100.950658,35.79528 L98.3292762,35.79528 C98.1252505,35.79528 98.0234956,35.71524 98.0234956,35.5550311 C98.0234956,35.4676444 98.0523842,35.3877333 98.1109352,35.3147822 L102.632773,27.76112" }),
	            _react2.default.createElement("path", { d: "M122.751999,28.0886267 C122.751999,27.7977244 122.896442,27.65208 123.187907,27.65208 L131.271553,27.65208 C131.561729,27.65208 131.707461,27.7977244 131.707461,28.0886267 L131.707461,28.4161333 C131.707461,29.5369511 131.547542,30.5631644 131.227704,31.4942578 C130.906577,32.4258667 130.444875,33.2265244 129.84002,33.8958444 C129.235165,34.5654222 128.503923,35.0857467 127.645003,35.4569467 C126.784794,35.8278889 125.817542,36.0134889 124.739379,36.0134889 C123.734727,36.0134889 122.766185,35.8531511 121.833754,35.5332489 C120.902613,35.2132178 120.072066,34.7255022 119.34379,34.0704889 C118.615385,33.4157333 118.033099,32.5969022 117.596159,31.6143822 C117.159348,30.63212 116.940749,29.4786933 116.940749,28.1541022 C116.940749,26.8735911 117.162702,25.7419467 117.606993,24.7592978 C118.051284,23.7767778 118.63718,22.9548533 119.365585,22.2924933 C120.093991,21.6302622 120.930986,21.1319778 121.877603,20.7969956 C122.82422,20.4624 123.8005,20.2949733 124.805152,20.2949733 C125.518339,20.2949733 126.191546,20.3787511 126.826063,20.54592 C127.459291,20.7133467 128.044801,20.9389022 128.583883,21.2227156 C129.122964,21.5065289 129.602721,21.8376444 130.025733,22.2160622 C130.447454,22.5946089 130.804693,22.9875911 131.096158,23.39488 C131.168379,23.4821378 131.20578,23.5840889 131.20578,23.7007333 C131.20578,23.8172489 131.132269,23.9482 130.986536,24.0934578 L129.632384,25.2943156 C129.502127,25.4108311 129.377029,25.4688311 129.260959,25.4688311 C129.130702,25.4688311 129.006894,25.3891778 128.889534,25.2287111 C128.32208,24.4865689 127.710777,23.92268 127.055625,23.5369156 C126.399183,23.1514089 125.613774,22.9583333 124.69553,22.9583333 C124.084227,22.9583333 123.494848,23.0673733 122.926104,23.28584 C122.35865,23.5040489 121.855679,23.8282044 121.418481,24.2572756 C120.982573,24.6867333 120.629203,25.2254889 120.359662,25.8727689 C120.090122,26.5205644 119.955351,27.2810089 119.955351,28.1541022 C119.955351,28.98376 120.090122,29.7225511 120.359662,30.3700889 C120.629203,31.0178844 120.982573,31.5636 121.418481,32.0074933 C121.855679,32.4516444 122.361229,32.78624 122.937711,33.0116667 C123.512903,33.2376089 124.106151,33.3501289 124.717454,33.3501289 C125.736293,33.3501289 126.588764,33.0990533 127.273579,32.5969022 C127.958393,32.09488 128.409777,31.3343067 128.627731,30.3155689 L123.187907,30.3155689 C122.896442,30.3155689 122.751999,30.1701822 122.751999,29.8787644 L122.751999,28.0886267" }),
	            _react2.default.createElement("path", { d: "M140.227016,26.2767067 C140.867981,26.2767067 141.370952,26.1457556 141.734639,25.8835956 C142.098325,25.6216933 142.280169,25.2363156 142.280169,24.7266889 C142.280169,24.21732 142.098325,23.8315556 141.734639,23.5695244 C141.370952,23.3076222 140.867981,23.1765422 140.227016,23.1765422 L136.907407,23.1765422 L136.907407,26.2767067 L140.227016,26.2767067 Z M134.067556,20.9497289 C134.067556,20.6588267 134.211999,20.5131822 134.503464,20.5131822 L140.074835,20.5131822 C141.69079,20.5131822 142.943059,20.8843822 143.831641,21.6266533 C144.720223,22.3689244 145.163869,23.4095733 145.163869,24.7484711 C145.163869,25.3891778 145.055537,25.9528089 144.836293,26.4403956 C144.618339,26.9283689 144.323005,27.3463556 143.95158,27.6957733 C143.580155,28.0450622 143.144247,28.3217867 142.641276,28.5253022 C142.138305,28.7292044 141.603093,28.8675022 141.035638,28.9401956 L145.732613,35.3147822 C145.790648,35.3877333 145.819021,35.4676444 145.819021,35.5550311 C145.819021,35.71524 145.724875,35.79528 145.535294,35.79528 L142.826989,35.79528 C142.66578,35.79528 142.54971,35.7700178 142.477488,35.7188489 C142.403977,35.6680667 142.324018,35.5844178 142.23632,35.4676444 L137.431013,28.9401956 L136.907407,28.9401956 L136.907407,35.3584756 C136.907407,35.6500222 136.760385,35.79528 136.470209,35.79528 L134.503464,35.79528 C134.211999,35.79528 134.067556,35.6500222 134.067556,35.3584756 L134.067556,20.9497289 L134.067556,20.9497289 Z" }),
	            _react2.default.createElement("path", { d: "M154.3605,33.3501289 C154.899581,33.3501289 155.442532,33.2519156 155.988062,33.05536 C156.534882,32.8588044 157.026246,32.5498578 157.463444,32.1274889 C157.899352,31.7055067 158.25659,31.1667511 158.533869,30.5119956 C158.809858,29.8569822 158.947853,29.0711467 158.947853,28.1541022 C158.947853,27.2373156 158.809858,26.4513511 158.533869,25.7963378 C158.25659,25.1413244 157.895483,24.6033422 157.451837,24.1808444 C157.00819,23.7589911 156.512957,23.4495289 155.966138,23.2531022 C155.420608,23.0565467 154.885395,22.9583333 154.3605,22.9583333 C153.836894,22.9583333 153.301681,23.0565467 152.754862,23.2531022 C152.209332,23.4495289 151.714099,23.7589911 151.270452,24.1808444 C150.825517,24.6033422 150.464409,25.1413244 150.18842,25.7963378 C149.911141,26.4513511 149.773147,27.2373156 149.773147,28.1541022 C149.773147,29.0711467 149.908562,29.8569822 150.178103,30.5119956 C150.446354,31.1667511 150.799723,31.7055067 151.236921,32.1274889 C151.674119,32.5498578 152.165483,32.8588044 152.711013,33.05536 C153.257833,33.2519156 153.807232,33.3501289 154.3605,33.3501289 Z M154.3605,36.0134889 C153.341661,36.0134889 152.37312,35.8496711 151.454875,35.5221644 C150.53792,35.1949156 149.729298,34.70372 149.030297,34.0487067 C148.331296,33.3936933 147.778028,32.5749911 147.370493,31.5927289 C146.962957,30.6102089 146.75919,29.4638711 146.75919,28.1541022 C146.75919,26.8588978 146.969406,25.7199067 147.392417,24.7376444 C147.814139,23.7551244 148.375145,22.9364222 149.074146,22.2814089 C149.773147,21.6266533 150.581769,21.1319778 151.498724,20.7969956 C152.416968,20.4624 153.370034,20.2949733 154.3605,20.2949733 C155.350966,20.2949733 156.305321,20.4624 157.222275,20.7969956 C158.14052,21.1319778 158.947853,21.6266533 159.646853,22.2814089 C160.345854,22.9364222 160.90686,23.7551244 161.329872,24.7376444 C161.751594,25.7199067 161.963099,26.8588978 161.963099,28.1541022 C161.963099,29.4638711 161.759332,30.6102089 161.351796,31.5927289 C160.942971,32.5749911 160.389703,33.3936933 159.690702,34.0487067 C158.991702,34.70372 158.183079,35.1949156 157.266124,35.5221644 C156.349169,35.8496711 155.380628,36.0134889 154.3605,36.0134889 L154.3605,36.0134889 Z" }),
	            _react2.default.createElement("path", { d: "M164.29998,20.9497289 C164.29998,20.6588267 164.445712,20.5131822 164.737178,20.5131822 L166.702633,20.5131822 C166.994099,20.5131822 167.139831,20.6588267 167.139831,20.9497289 L167.139831,29.3112667 C167.139831,30.0682311 167.227529,30.7050711 167.402924,31.2215289 C167.577029,31.7383733 167.816907,32.1531378 168.123849,32.4658222 C168.4295,32.7791511 168.785449,33.0044489 169.192984,33.1426178 C169.60181,33.2813022 170.031269,33.3501289 170.482654,33.3501289 C170.934038,33.3501289 171.363498,33.2813022 171.771033,33.1426178 C172.178569,33.0044489 172.535807,32.7791511 172.841458,32.4658222 C173.14711,32.1531378 173.388278,31.7383733 173.562384,31.2215289 C173.737779,30.7050711 173.824186,30.0682311 173.824186,29.3112667 L173.824186,20.9497289 C173.824186,20.6588267 173.969919,20.5131822 174.261384,20.5131822 L176.22813,20.5131822 C176.518305,20.5131822 176.664038,20.6588267 176.664038,20.9497289 L176.664038,29.0930578 C176.664038,31.4363867 176.122377,33.1753556 175.036475,34.3106089 C173.951864,35.4459911 172.433923,36.0134889 170.482654,36.0134889 C168.530095,36.0134889 167.012154,35.4459911 165.927542,34.3106089 C164.84293,33.1753556 164.29998,31.4363867 164.29998,29.0930578 L164.29998,20.9497289" }),
	            _react2.default.createElement("path", { d: "M185.576941,27.3245733 C187.252221,27.3245733 188.089217,26.6334711 188.089217,25.2506222 C188.089217,23.8679022 187.252221,23.1765422 185.576941,23.1765422 L182.409514,23.1765422 L182.409514,27.3245733 L185.576941,27.3245733 Z M179.569662,20.9497289 C179.569662,20.6588267 179.715395,20.5131822 180.00686,20.5131822 L185.882593,20.5131822 C186.741512,20.5131822 187.488231,20.6369156 188.121458,20.8843822 C188.755976,21.1319778 189.279581,21.4736622 189.694855,21.9103378 C190.110128,22.3470133 190.419649,22.8567689 190.623417,23.4384444 C190.827184,24.0208933 190.929068,24.6467778 190.929068,25.3162267 C190.929068,25.9566756 190.827184,26.56052 190.623417,27.1280178 C190.419649,27.6957733 190.116577,28.1907067 189.716779,28.6126889 C189.315692,29.0348 188.81788,29.3696533 188.220763,29.6168622 C187.623646,29.8644578 186.923356,29.9880622 186.123761,29.9880622 L182.409514,29.9880622 L182.409514,35.3584756 C182.409514,35.6500222 182.263781,35.79528 181.972316,35.79528 L180.00686,35.79528 C179.715395,35.79528 179.569662,35.6500222 179.569662,35.3584756 L179.569662,20.9497289 L179.569662,20.9497289 Z" })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = OLXLogo;
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(54);
	
	__webpack_require__(353);
	
	var _Header = __webpack_require__(202);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(201);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(203);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loading: 'is-loading'
	    };
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '57x57', href: '/icons/apple-touch-icon-57x57.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '60x60', href: '/icons/apple-touch-icon-60x60.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '72x72', href: '/icons/apple-touch-icon-72x72.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '76x76', href: '/icons/apple-touch-icon-76x76.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '114x114', href: '/icons/apple-touch-icon-114x114.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '120x120', href: '/icons/apple-touch-icon-120x120.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '144x144', href: '/icons/apple-touch-icon-144x144.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '152x152', href: '/icons/apple-touch-icon-152x152.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '180x180', href: '/icons/apple-touch-icon-180x180.png' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: '/icons/favicon-16x16.png', sizes: '16x16' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: '/icons/favicon-32x32.png', sizes: '32x32' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: '/icons/favicon-96x96.png', sizes: '96x96' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: '/icons/favicon-128x128.png', sizes: '128x128' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: '/icons/favicon-196x196.png', sizes: '196x196' }),
	        _react2.default.createElement('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-startup-image', href: '/icons/favicon-512x512.png' }),
	        _react2.default.createElement('meta', { name: 'application-name', content: 'PME' }),
	        _react2.default.createElement('meta', { name: 'msapplication-TileColor', content: '#FFFFFF' }),
	        _react2.default.createElement('meta', { name: 'msapplication-square70x70logo', content: '/icons/mstile-70x70.png' }),
	        _react2.default.createElement('meta', { name: 'msapplication-TileImage', content: '/icons/mstile-144x144.png' }),
	        _react2.default.createElement('meta', { name: 'msapplication-square150x150logo', content: '/icons/mstile-150x150.png' }),
	        _react2.default.createElement('meta', { name: 'msapplication-wide310x150logo', content: '/icons/mstile-310x150.png' }),
	        _react2.default.createElement('meta', { name: 'msapplication-square310x310logo', content: '/icons/mstile-310x310.png' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'PME' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'People Management Essentials by OLXGroup' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: '/icons/favicon-512x512.png' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: '/index.html' }),
	        _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' })
	      ),
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(_Menu2.default, null),
	      children(),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9f2ca20575d654476eba.js